import type { RoomSnapshot } from "../../models/contracts";
export function reconcileSnapshot(current: RoomSnapshot | null, incoming: RoomSnapshot): RoomSnapshot {
  if (!current || incoming.revision > current.revision) return incoming;
  if (incoming.revision < current.revision) return current;
  const currentPlaybackAt = Date.parse(current.hostPlayback?.updatedAt ?? "");
  const incomingPlaybackAt = Date.parse(incoming.hostPlayback?.updatedAt ?? "");
  return currentPlaybackAt > incomingPlaybackAt ? { ...incoming, hostPlayback: current.hostPlayback } : incoming;
}
